import { AsyncComponent } from '@frontend/components/common';
import { lazy } from 'react';
import { Navigate, Route } from 'react-router-dom';

const BundleDetail = lazy(() => import('../bundle/bundle-detail/bundle-detail.component'));
const BundleOverview = lazy(() => import('../bundle/bundle-overview'));
const BundleCreate = lazy(() => import('../bundle/bundle-create/bundle-create.component'));
const BundleUpdate = lazy(() => import('../bundle/bundle-update/bundle-update.component'));

export function BundleRoutes() {
    return (
        <Route path='bundles'>
            <Route
                index
                element={
                    <AsyncComponent>
                        <BundleOverview />
                    </AsyncComponent>
                }
            />
            <Route
                path='create'
                element={
                    <AsyncComponent>
                        <BundleCreate />
                    </AsyncComponent>
                }
            />
            <Route
                index
                element={<Navigate to='/bundles' />}
            />
            <Route path=':bundleId'>
                <Route
                    path='detail'
                    element={
                        <AsyncComponent>
                            <BundleDetail />
                        </AsyncComponent>
                    }
                />
                <Route
                    path='update'
                    element={
                        <AsyncComponent>
                            <BundleUpdate />
                        </AsyncComponent>
                    }
                />
            </Route>
        </Route>
    );
}
